//const baseApiUrl = "https://10.10.10.105:6792/api";
const baseApiUrl = "https://api.havayar.com/api";
//auth
const apiLoginByNationalCodeEndpoint = baseApiUrl + "/HmaLoginByNationalCode";
const apiLoginBySerialEndpoint = baseApiUrl + "/HmaLoginBySerial";
const apiLoginByMobileEndpoint = baseApiUrl + "/HmaLoginByMobile";
const apiForgetPasswordEndpoint = baseApiUrl + "/HmaForgetPassword";
const apiSignUpEndpoint = baseApiUrl + "/HmaSignUpByMObile";
//profile
const apiUserProductionOrderItems = baseApiUrl + "/HmaUserProductionOrderItems";
const apiUserProfileInfo = baseApiUrl + "/HmaUserProfileInfo";
const apiUserProfileSupportRequests = baseApiUrl + "/HmaUserProfileSupportRequests";
//complaints
const apiCustomerAddComplaintEndpoint =
    baseApiUrl + "/HmaRegisterCustomerComplaint";
const apiCustomerComplaintListEndpoint = baseApiUrl + "/HmaCustomerComplaints";
const apiRegisterPartRequestEndpoint = baseApiUrl + "/HmaRegisterPartRequest";
//news
const apiNewsEndpoint = baseApiUrl + "/HavayarNews";
const apiNewsByIdEndpoint = baseApiUrl + "/HavayarNewsById";
//visitHistory
const apiVisitHistoryEndpoint = baseApiUrl + "/HmaCustomerVisitRequests";
//CustomerCertificates
const apiCustomerCertificatesEndpoint = baseApiUrl + "/CustomerCertificates";
const apiSendCustomerCertificateEndpoint = baseApiUrl + "/SendCustomerCertificate";
//serviceCenter
const apiRegisterServiceRequestEndpoint = baseApiUrl + "/HmaRegisterServiceRequest";
//DataSheet
const apiDataSheetByPartCodeEndpoint = baseApiUrl + "/HmaDataSheetByPartCode";
//Production Order RunTime 
const apiHmaProductionOrderRunTimeBySerialEndpoint = baseApiUrl + "/HmaProductionOrderRunTimeBySerial";

//auth Methods
export function getLoginByNationalCodeEndpoint() {
    return apiLoginByNationalCodeEndpoint;
}

export function getLoginBySerialEndpoint() {
    return apiLoginBySerialEndpoint;
}

export function getLoginByMobileEndpoint() {
    return apiLoginByMobileEndpoint;
}

export function getForgetPasswordEndpoint() {
    return apiForgetPasswordEndpoint;
}

export function getSignUpEndpoint() {
    return apiSignUpEndpoint;
}

//profile Methods
export function getUserProductionOrderItemsEndpoint() {
    return apiUserProductionOrderItems;
}

export function getUserProfileInfoEndpoint() {
    return apiUserProfileInfo;
}

export function getUserProfileSupportRequestsEndpoint() {
    return apiUserProfileSupportRequests;
}

//complaints Methods
export function getCustomerAddComplaintEndpoint() {
    return apiCustomerAddComplaintEndpoint;
}

export function getCustomerComplaintListEndpoint() {
    return apiCustomerComplaintListEndpoint;
}
//consulling Methods

export function getRegisterPartRequestEndpoint() {
    return apiRegisterPartRequestEndpoint;
}

// News Methods
export function getNewsEndpoint() {
    return apiNewsEndpoint;
}

export function getNewsEndpointById() {
    return apiNewsByIdEndpoint;
}

//visitHistoryEndPoint
export function getVisitHistoryEndpoint() {
    return apiVisitHistoryEndpoint;
}

//CertificatesEndPoint
export function getCustomerCertificateEndpoint() {
    return apiCustomerCertificatesEndpoint;
}

export function getSendCustomerCertificateEndpoint() {
    return apiSendCustomerCertificateEndpoint;
}

//serviceCenterEndPoint
export function getRegisterServiceRequestEndpoint() {
    return apiRegisterServiceRequestEndpoint;
}

//DataSheet
export function getDataSheetByPartCodeEndpoint() {
    return apiDataSheetByPartCodeEndpoint;
}

//ProductionOrderRunTime
export function getProductionOrderRunTimeBySerialEndpoint() {
    return apiHmaProductionOrderRunTimeBySerialEndpoint;
}

//Export
export default {
    getLoginByNationalCodeEndpoint,
    getLoginBySerialEndpoint,
    getUserProductionOrderItemsEndpoint,
    getUserProfileInfoEndpoint,
    getUserProfileSupportRequestsEndpoint,
    getCustomerAddComplaintEndpoint,
    getCustomerComplaintListEndpoint,
    getRegisterPartRequestEndpoint,
    getNewsEndpoint,
    getNewsEndpointById,
    getVisitHistoryEndpoint,
    getCustomerCertificateEndpoint,
    getSendCustomerCertificateEndpoint,
    getRegisterServiceRequestEndpoint,
    getLoginByMobileEndpoint,
    getSignUpEndpoint,
    getForgetPasswordEndpoint,
    getDataSheetByPartCodeEndpoint,
    getProductionOrderRunTimeBySerialEndpoint,
};
